"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnsHandlerTypeString = getColumnsHandlerTypeString;
const DynamicColumnConfigProvider_1 = require("../components/DynamicColumnConfigProvider");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getColumnsHandlerTypeString(provider, params = {}, filterOptions) {
    return (0, DynamicColumnConfigProvider_1.defineColumnHandler)({
        name: provider.type,
        label: provider.label,
        columnType: 'string',
        arrayColumnType: 'string-array',
        filterOptions,
        format: (columnValue, data) => {
            if (columnValue) {
                return data.get(columnValue) ?? columnValue;
            }
            else {
                return undefined;
            }
        },
        formatArray: (columnValue, data) => {
            return columnValue ? columnValue.map((value) => data.get(value)).join('; ') : undefined;
        },
        loadData: () => provider.getValues(params).then((resp) => resp.reduce((prev, current) => prev.set(current.value, current.label), new Map())),
    });
}
